import {firebaseApp} from './firebase'

import {
    getFirestore,
    doc,
    getDoc,
    // addDoc  // auto-generated Id
    setDoc,  // own Id
    updateDoc, // change only parts of doc (one property?)
    deleteDoc,
    collection,
    getDocs,
    // serverTimestamp,
    // Bytes,
    query as firebaseQuery,
    where,
    onSnapshot
} from 'firebase/firestore'


const db = getFirestore(firebaseApp)

export const DATABASE = {
    // CHANGE ALSO IN CLOUD FUNCTION .auth.user().onDelete() & Manage-Users !!!
    userSettingsCollection: 'user-stgs',  //docId == uid

    userWordsMainCollection: 'user-words-v1',  //docId == uid
    userWordsSubcollection: 'user-words',

    // uInt8ArrToBytes(uInt8arr) {
    //     return Bytes.fromUint8Array(uInt8arr)
    // },
    // bytesToUInt8Arr(bytes) {
    //     return bytes.toUint8Array()
    // },

    async getDoc(collection, docId) {
        const docRef = doc(db, collection, docId)
        const response = await getDoc(docRef)
        return response.data()
    },
    async setDoc(collection, docId, docObj) {
        const docRef = doc(db, collection, docId)
        await setDoc(docRef, docObj)
    },
    //merge compared to update:
    //no error if doc doesn't exist, it's then created
    async setDocMerge(collection, docId, docObj) {
        const docRef = doc(db, collection, docId)
        await setDoc(docRef, docObj, {merge: true})
    },
    async updateDoc(collection, docId, partialDocObj) {
        const docRef = doc(db, collection, docId)
        await updateDoc(docRef, partialDocObj)
    },
    async deleteDoc(collection, docId) {
        await deleteDoc(doc(db, collection, docId));
    },

    async getDocs(collectionId) {
        const querySnapshot = await getDocs(collection(db, collectionId))
        return querySnapshot.docs.map(doc => doc.data())
    },

    async getAllIdsInCollection(collectionId) {
        const querySnapshot = await getDocs(collection(db, collectionId))
        return querySnapshot.docs.map(doc => doc.id)
    },

    subscribeDoc(collection, docId, callback, errorCallback) {
        const docRef = doc(db, collection, docId)
        // TODO wrap snapshop callback to wrap extracting .data() if doc exists and return doc or null
        return onSnapshot(docRef, callback, errorCallback)
    },

    subscribeCollection(collectionPath, callback, errorCallback) {
        // QUESTION is the query even needed - just collection enough..?!
        const q = firebaseQuery(collection(db, collectionPath))
        return onSnapshot(q, callback, errorCallback)
    },

    subscribeQuery(collectionName, w, callback, errorCallback) {
        const q = firebaseQuery(collection(db, collectionName), where(...w));
        return onSnapshot(q, (querySnapshot) => {
                callback(querySnapshot.docs.map(doc => doc.data()))
            },
            errorCallback
        );
    }

    // async getCollectionGroup(collectionId) {
    //     const querySnapshot = await getDocs(collectionGroup(db, collectionId));
    //     return querySnapshot.docs.map(doc => doc.data())
    // }

}
